// PermissionsContext.tsx
import React, { createContext, useContext, ReactNode, useEffect, useState } from 'react';
import Auth from './../utils/auth';
import { useSelector } from 'react-redux';
import { decodeWithKeyAndShift } from '../utils/base64Utils';
import { RootState } from '@store/reducers';
//type Permissions = { [key: string]: string[] }; // e.g., { "User_Module": ["view", "edit"], "Admin_Module": ["view"] }
type Permissions = any[]
type PermissionsContextType = {
  permissions: Permissions;
};
const PermissionsContext = createContext<PermissionsContextType>({ permissions: [] });
// const PermissionsContext = createContext<PermissionsContextType | null>(null);

export const PermissionsProvider = ({
  children,
  userPermissions,
}: {
  children: ReactNode;
  userPermissions: Permissions | any;
}) => {
  const [permission, setPermission] = useState<Permissions | any>(usePermissions);

  const usePermisionNew = useSelector((state:RootState)=>state.auth);

  const handlePermision = () => {
    setPermission(usePermissions);
  };

  const setPermisionContext = () => {
    if (usePermisionNew.userPermissions) {
      return usePermisionNew.userPermissions ? JSON.parse(decodeWithKeyAndShift(usePermisionNew.userPermissions)) : JSON.stringify({})
    } else {
      return userPermissions;
    }
  };

  useEffect(() => {
    handlePermision();
  }, [usePermisionNew]);
  // localStorage.getItem('userPermissions')

  return (
    <PermissionsContext.Provider value={{ permissions: setPermisionContext() }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => {
  return useContext(PermissionsContext);
};